export const unsplashTags = [
  'gradient',
  'clouds',
  'landscape',
  'ocean',
  'cat',
  'autumn',
  'abstract'
]
